import {RouteDefinition} from '../../../routes';
import {RoomListScreen} from './RoomListScreen';
import {AreaListScreen} from './AreaListScreen';
import {RoomEditScreen} from './RoomEditScreen';
import {AreaEditScreen} from './AreaEditScreen';

export const ProjectInformationSettingsRoutes: RouteDefinition[] = [
    {
        name: 'Proje Bilgileri',
        routerLink: '/settings/project-information',
        component: AreaListScreen,
    },
    {
        name: 'Alan Oluştur',
        routerLink: '/settings/area/edit',
        component: AreaEditScreen,
    },
    {
        name: 'Alan Detay',
        routerLink: '/settings/area/edit/:id',
        component: AreaEditScreen,
    },
    {
        name: 'Oda Listesi',
        routerLink: '/settings/floor/:id/room',
        component: RoomListScreen,
    },
    {
        name: 'Oda Oluştur',
        routerLink: '/settings/floor/:floor_id/room/edit',
        component: RoomEditScreen,
    },
    {
        name: 'Oda Detay',
        routerLink: '/settings/floor/:floor_id/room/edit/:id',
        component: RoomEditScreen,
    },
];
